// Shared theme tokens for "نبض السوق AI" funnel.
// Premium dark-navy aesthetic — deep midnight + amber-gold + mint pulse.

export const NABD_THEME = {
  bg: "#06090F",
  bgRaised: "#0B1018",
  bgCard: "#0E141C",
  bgInk: "#040608",
  text: "#E8ECEF",
  textMuted: "#9AA5B1",
  textDim: "#6B7480",
  textFaint: "#404853",
  gold: "#F4B842",        // primary accent — premium amber
  goldBright: "#FFD27A",
  goldDeep: "#A47323",
  goldLine: "rgba(244,184,66,0.30)",
  pulse: "#00D4A8",        // mint green — "live market" indicator
  pulseDim: "rgba(0,212,168,0.16)",
  danger: "#EF6B6B",
};

export const NABD_FONT_AR =
  "'Tajawal','IBM Plex Sans Arabic',-apple-system,system-ui,sans-serif";
export const NABD_FONT_DISPLAY =
  "'Tajawal','IBM Plex Sans Arabic',serif";

export const ensureNabdFonts = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById("nabd-font")) return;
  const l = document.createElement("link");
  l.id = "nabd-font";
  l.rel = "stylesheet";
  l.href =
    "https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800;900&display=swap";
  document.head.appendChild(l);
};

// Stable per-browser id used for analytics.
export const nabdVisitorId = () => {
  try {
    let v = localStorage.getItem("nabd_vid");
    if (!v) {
      v = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `${Math.random().toString(36).slice(2)}${Date.now()}`;
      localStorage.setItem("nabd_vid", v);
    }
    return v;
  } catch {
    return "anon";
  }
};
